import React, { useMemo } from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import { getSelectedBp } from 'features/bpDetails/ducks/selectors'
import ChecklistOverviewSummary from 'features/analytics/compontents/ChecklistOverviewSummary'

const getTemplates = bp =>
  bp?.checklistTemplates || bp?.checklist_templates || []

const getItems = template =>
  template?.items ||
  template?.analyticsTemplateItems ||
  template?.analytics_template_items ||
  []

const getOverviewEntries = item =>
  item?.checklistOverview?.entries || item?.checklist_overview?.entries || []

const UnitChecklistOverview = ({ unit }) => {
  const bp = useSelector(getSelectedBp)

  const relevantTemplates = useMemo(() => {
    return getTemplates(bp)
      .map(template => {
        const relevantItems = getItems(template).filter(item => {
          const entries = getOverviewEntries(item)
          if (!entries.length) return false

          return entries.some(entry => {
            const entryUnitId = entry?.unit?.id || null
            return !entryUnitId || String(entryUnitId) === String(unit?.id)
          })
        })

        if (!relevantItems.length) return null

        return {
          id: template.id,
          name: template.name,
          items: relevantItems
        }
      })
      .filter(Boolean)
  }, [bp, unit?.id])

  if (!relevantTemplates.length) {
    return null
  }

  return (
    <SectionWrap>
      <SectionTitle>Checklist Upload Overview</SectionTitle>
      <SectionIntro>
        See who is assigned, what has already been uploaded for this unit, and
        open the correct upload link if needed.
      </SectionIntro>
      <TemplatesList>
        {relevantTemplates.map(template => (
          <TemplateCard key={template.id}>
            <TemplateTitle>{template.name}</TemplateTitle>
            <ItemsList>
              {template.items.map(item => (
                <ItemCard key={item.id}>
                  <ItemTitle>
                    {item.title || item?.fileType?.name || 'Checklist item'}
                  </ItemTitle>
                  <ChecklistOverviewSummary
                    item={item}
                    unitId={unit?.id}
                    compact={false}
                  />
                </ItemCard>
              ))}
            </ItemsList>
          </TemplateCard>
        ))}
      </TemplatesList>
    </SectionWrap>
  )
}

export default UnitChecklistOverview

const SectionWrap = styled.div`
  width: 100%;
  margin-top: 30px;
  border: 1px solid #edf0f4;
  border-radius: 20px;
  background: #fff;
  padding: 24px;
  box-sizing: border-box;
`

const SectionTitle = styled.div`
  color: #172033;
  font-size: 24px;
  font-weight: 700;
`

const SectionIntro = styled.div`
  margin-top: 8px;
  color: #6f7785;
  font-size: 14px;
  line-height: 1.5;
`

const TemplatesList = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const TemplateCard = styled.div`
  border: 1px solid #edf0f4;
  border-radius: 16px;
  padding: 18px;
`

const TemplateTitle = styled.div`
  color: #172033;
  font-size: 18px;
  font-weight: 700;
`

const ItemsList = styled.div`
  margin-top: 14px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`

const ItemCard = styled.div`
  border: 1px solid #edf0f4;
  border-radius: 14px;
  padding: 14px;
`

const ItemTitle = styled.div`
  color: #172033;
  font-size: 15px;
  font-weight: 700;
`
